import { StylesProps } from 'types/common';

export const styles: StylesProps = {
  switch: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '300px',
  },
};
